<template>

	<v-checkbox
		class="pt-0 mt-n2"
		:label="field.template.name"
		v-model="field.value"
	></v-checkbox>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------


export default
{
	name: 'ContentFieldBoolean',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		value: '',
	}),



	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		
		this.field.value = this.field.template.typeProperties.defaultValue;

		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}
		
	},

	mounted()
	{
		
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		
	}

}

</script>

